import { css } from '@emotion/core';
import styled from '@emotion/styled';
import { useWatch } from 'react-hook-form';

const currentlyEditingStyles = ({ currentlyEditing }) => css`
  #${currentlyEditing}-preview {
    span {
      background-color: #FFFC92;
      color: black;
    }
  }
`;

const Container = styled.div`
  width: 300px;
  flex-direction: column;
  border-radius: 4px;
  box-shadow: inset 0 0 0 1px #00000019, 0 1px #00000003;
  overflow: hidden;
  margin: 20px;
  
  & > p {
    margin: 0;

    & > span {
      transition: background-color 200ms, color 200ms;
    }
  }

  #headline-message-preview {
    padding: 20px 20px 0;
    text-align: center;
    font-size: 18px;
  }

  #description-preview {
    font-size: 12px;
    padding: 20px;
    text-align: center;
  }

  #button-text-preview {
    margin-top: auto;
    padding: 12px;
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    text-align: center;
    text-shadow: 0 1px #00000019;
    background: #4080ff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px; 
  
  }

  ${currentlyEditingStyles}
`;


export default function Preview({ control, currentlyEditing }) {
  const callingCard = useWatch({
    control,
    name: 'callingCard',
  });

  return (
    <Container role="note" currentlyEditing={currentlyEditing}>
      <p data-testid="headline-preview" id="headline-message-preview">
        <span>{callingCard.headline}</span>
      </p>
      <p data-testid="description-preview" id="description-preview">
        <span>{callingCard.description}</span>
      </p>
      <p data-testid="buttonText-preview" id="button-text-preview">
        <span>{callingCard.buttonText}</span>
      </p>
    </Container>
  );
}
